import StarIcon from './star.svg';

const Star = (props) => (
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  <StarIcon {...props} focusable="false" />
);

export default Star;
